import { isEmpty } from 'lodash'
import { parseRef } from "../../firebase"

import { defaultListener } from '../helper'

export default {
  state: {
    users: {},
    filters: {}
  },
  mutations: {
    addUser(state, user) {
      const { id } = user

      if (id) {
        const newState = { ...state.users }
        newState[ id ] = user
        state.users = newState
      }
    },
    removeUser(state, id) {
      if (state.users[ id ]) {
        const newState = { ...state.users }
        delete state.users[ id ]
        state.users = newState
      }
    }
  },
  getters: {
    getUser: (state) => (id) => state.users[ id ] || {},
    activeUsers: (state) => Object.values(state.users),
    allUsers: (state) => Object.values(state.users),
    undeletedUsers(state, getters){
      return getters.allUsers.filter(u => u.deleted !== true)
    }
  },
  actions: {
    async inviteTenantUser({ }, data) {
      const { uid } = data

      const result = await this.$api.post(`/api/tenant/invite/${uid}`)

      return result

    },
    async fetchTenantUsers({  }){
      // Uses tenant stored in the authentication token
      const result = await this.$api.get(`/api/tenant/users`)

      return result
    },
    ensureUser({  commit, getters }, id) {
      const user = getters.getUser(id)

      const sessionTenant = getters.getSessionTenant

      if (isEmpty(user)) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('users')
          .doc(id)
          .get()
          .then(ref => {
            const data = parseRef(ref)

            if (data) commit('addUser', data)
          })
          .catch(e => console.log(e))
      }
    },
    initUsers({ commit, getters }) {
      const sessionTenant = getters.getSessionTenant

      if (sessionTenant) {
        this.$firebase.firestore()
          .collection('tenants')
          .doc(sessionTenant)
          .collection('users')
          .onSnapshot(
            defaultListener.bind(this, commit, 'addUser', 'removeUser'),
            e => console.log(e)
          )
      }
    }
  }
}
